import {listener} from "../../../../modules/vegas/js/util";

function recaptchaRender() {
	if (window.smartCaptcha) {
		const container = document.getElementById('tracking-captcha');
		const widgetId = window.smartCaptcha.render(container, {
			sitekey: container.dataset.sitekey,
			hl: 'ru',
			callback: (token) => {
				let form = document.getElementById('form-tracking');
				form.classList.add('captcha-success');
				form.insertAdjacentHTML('beforeend', `<input type="hidden" name="smart-token" value="${token}" />`);
				form.requestSubmit();
			}
		});
	}
}

listener('submit', '#form-tracking[data-withcaptcha="1"]:not(.captcha-success)', function (el, e) {
	document.getElementById('tracking-captcha-container').classList.remove('d-none');
	recaptchaRender();
}, true);

listener('submit', '#form-tracking[data-withcaptcha="1"].captcha-success', function (el, e) {
	document.getElementById('tracking-captcha-container').classList.add('d-none');
	document.getElementById('tracking-wrapper-loader')?.classList.add('fade', 'show');
});
listener('submit', '#form-tracking[data-withcaptcha="0"]', function (el, e) {
	document.getElementById('tracking-wrapper-loader')?.classList.add('fade', 'show');
});
